export function btNL2BR(str) {
	return str.replace(/\n/g, '<br />');
}

export function btStripTags(input, allowed = '') {
	// making sure the allowed arg is a string containing only tags in lowercase (<a><b><c>)
	var allowedStr = (((allowed || '') + '').toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join('')

	var tags = /<\/?([a-z0-9]*)\b[^>]*>?/gi
	var commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi

	// removes tha '<' char at the end of the string to replicate PHP's behaviour
	var after = (input.substring(input.length - 1) === '<') ? input.substring(0, input.length - 1) : input;
  var before;

	// recursively remove tags to ensure that the returned string doesn't contain forbidden tags after previous passes (e.g. '<<bait/>switch/>')
	while (before !== after) {
		before = after;
		after = before.replace(commentsAndPhpTags, '').replace(tags, function ($0, $1) {
			return allowedStr.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : ''
		});
	}
  return after;
}

export function btTrim(str) {
	return str.replace(/^\s+|\s+$/gm, '');
}

export function btDirname(path) {
	return path.replace(/\\/g, '/')
		.replace(/\/[^/]*\/?$/, '')
}
